/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetWhitelistedChannelsResponse,
  PostWhitelistedChannelRequest,
  PostWhitelistedChannelResponse,
  ProblemDetails
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiV1Whitelist = (

 signal?: AbortSignal
) => {


      return apiClient<GetWhitelistedChannelsResponse | null>(
      {url: `/api/v1/whitelist`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1WhitelistQueryKey = () => {
    return [
    `/api/v1/whitelist`
    ] as const;
    }


export const getGetApiV1WhitelistQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Whitelist>>, TError = ProblemDetails | null>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Whitelist>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1WhitelistQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Whitelist>>> = ({ signal }) => getApiV1Whitelist(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Whitelist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1WhitelistQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Whitelist>>>
export type GetApiV1WhitelistQueryError = ProblemDetails | null


export function useGetApiV1Whitelist<TData = Awaited<ReturnType<typeof getApiV1Whitelist>>, TError = ProblemDetails | null>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Whitelist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Whitelist>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Whitelist>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Whitelist<TData = Awaited<ReturnType<typeof getApiV1Whitelist>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Whitelist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Whitelist>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Whitelist>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Whitelist<TData = Awaited<ReturnType<typeof getApiV1Whitelist>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Whitelist>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Whitelist<TData = Awaited<ReturnType<typeof getApiV1Whitelist>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Whitelist>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1WhitelistQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1Whitelist = (
    postWhitelistedChannelRequestNull: PostWhitelistedChannelRequest | null,
 signal?: AbortSignal
) => {


      return apiClient<PostWhitelistedChannelResponse | null>(
      {url: `/api/v1/whitelist`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postWhitelistedChannelRequestNull, signal
    },
      );
    }




export const getPostApiV1WhitelistMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Whitelist>>, TError,{data: PostWhitelistedChannelRequest | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1Whitelist>>, TError,{data: PostWhitelistedChannelRequest | null}, TContext> => {

const mutationKey = ['postApiV1Whitelist'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1Whitelist>>, {data: PostWhitelistedChannelRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1Whitelist(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1WhitelistMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1Whitelist>>>
    export type PostApiV1WhitelistMutationBody = PostWhitelistedChannelRequest | null
    export type PostApiV1WhitelistMutationError = ProblemDetails | null

    export const usePostApiV1Whitelist = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Whitelist>>, TError,{data: PostWhitelistedChannelRequest | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1Whitelist>>,
        TError,
        {data: PostWhitelistedChannelRequest | null},
        TContext
      > => {
      return useMutation(getPostApiV1WhitelistMutationOptions(options), queryClient);
    }
    export const deleteApiV1WhitelistId = (
    id: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/whitelist/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1WhitelistIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1WhitelistId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1WhitelistId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteApiV1WhitelistId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1WhitelistId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiV1WhitelistId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1WhitelistIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1WhitelistId>>>

    export type DeleteApiV1WhitelistIdMutationError = ProblemDetails | null

    export const useDeleteApiV1WhitelistId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1WhitelistId>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1WhitelistId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1WhitelistIdMutationOptions(options), queryClient);
    }
